<template>
  <div>
    <div
      v-if="this.$store.state.menuOpen"
      class="header-menu-container"
      :style="containerStyles"
      @click="handleMenuClick"
      tabindex="-1"
      v-focus.lazy="true"
    >
      <div
        id="more-menu"
        class="header-menu"
        v-if="menuOpen === 'more'"
        :class="{ open: menuOpen }"
      >
        <close-icon @click.native="closeMenu" tabindex="0"></close-icon>
        <ul class="menu-items header-menu-content">
          <li>
            <router-link :to="homeDestination">{{
              $t('message.welcome-message')
            }}</router-link>
          </li>
          <li>
            <a
              v-if="currentEdition.helpdesk_type === 'link'"
              :href="currentEdition.helpdesk_location"
              >{{ $t('message.help-center') }}</a
            >
            <a v-else href="/guide">{{ $t('message.user-guide') }}</a>
          </li>
          <li v-if="currentUser.admin_level">
            <a href="/auth/knowledge-center">{{
              $t('message.knowledge-center')
            }}</a>
          </li>
          <li v-if="currentEdition.id === 71">
            <a href="/auth/jbc/request">{{ $t('message.jbc') }}</a>
          </li>
          <hr />
          <li>
            <router-link to="/about">{{ $t('message.about') }}</router-link>
          </li>
          <li>
            <router-link to="/privacy">{{ $t('message.privacy') }}</router-link>
          </li>
          <li
            v-if="
              currentEdition.enable_community && !$store.getters.standAndDeliver
            "
          >
            <a href="/community_guidelines">{{
              $t('message.community-guidelines')
            }}</a>
          </li>
          <li v-if="currentEdition.id !== 234">
            <router-link to="/termsandconditions">{{
              $t('message.ts-and-cs')
            }}</router-link>
          </li>
          <li v-if="currentUser.permissions.includes('edit_program_content')">
            <a href="/cms2/management">{{ $t('message.authoring-tools') }}</a>
          </li>
          <li v-else-if="resourceEditor">
            <router-link to="/cms/resources">{{
              $t('message.manage-resources')
            }}</router-link>
          </li>
        </ul>
      </div>

      <div
        id="notification-menu"
        class="header-menu"
        v-if="menuOpen === 'notifications'"
        :class="{ open: menuOpen }"
      >
        <close-icon @click.native="closeMenu" tabindex="0"></close-icon>
        <div
          class="notification-panel header-menu-content global-notifications"
        >
          <notifications></notifications>
        </div>
      </div>

      <div
        id="account-menu"
        class="header-menu"
        v-if="menuOpen === 'profile'"
        :class="{ open: menuOpen }"
      >
        <close-icon @click.native="closeMenu" tabindex="0"></close-icon>
        <ul class="menu-items header-menu-content">
          <li>
            <router-link
              :to="{ name: 'profile', params: { userId: currentUser.id } }"
              >{{ $t('message.profile') }}</router-link
            >
          </li>
          <li>
            <router-link to="/settings">{{
              $t('message.settings')
            }}</router-link>
          </li>
          <li v-if="currentUser.has_subscriptions">
            <router-link to="/settings/billing">{{
              $t('message.billing-and-payment')
            }}</router-link>
          </li>
          <li
            v-if="
              currentEdition.enable_comment_moderation &&
                (currentUser.admin_level === 'sales' ||
                  currentUser.comment_moderator)
            "
          >
            <a href="/moderator/comments">{{
              $t('message.moderate-comments')
            }}</a>
          </li>
          <li>
            <a href="/signout" class="logout">{{ $t('message.sign-out') }}</a>
          </li>
          <li v-for="lang in visibleLanguages" v-bind:key="lang.name">
            <a href="" @click.prevent="setLanguage(lang)" :lang="lang.code">{{ lang.name }}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="header-menu-backdrop" v-if="menuOpen" @click="closeMenu"></div>
  </div>
</template>

<style lang="less" scoped>
.header-menu-container {
  position: absolute;
  padding-bottom: 40px;
  z-index: 1100;
  &:focus {
    outline: none;
  }
  
  @media (max-width: 815px) {
    width: 93vw;
    max-width: 400px;
    left: 50% !important;
    transform: translateX(-50%);
    top: 5px;
  }
}

.header-menu {
  display: block !important;
  background: #ffffff;
  box-sizing: border-box;
  padding: 12px 40px 12px 20px;
  -webkit-box-shadow: 0px 0px 15px 0px rgba(57, 57, 57, 0.16); /* Android 2.3+, iOS 4.0.2-4.2, Safari 3-4 */
  box-shadow: 0px 0px 15px 0px rgba(57, 57, 57, 0.16);
  border-radius: 4px;
  opacity: 0;
  transition: opacity 0.3s;
  z-index: 1000;

  &.open {
    opacity: 1;
    @media (prefers-contrast: more) {
      outline: 1px solid transparent;
      &:focus {
        outline-width: 3px;
      }
    }
  }

  ul.menu-items {
    padding-right: 60px;

    hr {
      background: transparent;
      border-top: none;
      border-bottom: 1px solid #ccc;
      display: block;
      margin-top: 12px;
      margin-bottom: 12px;
    }

    li {
      padding: 6px 0px;

      a {
        font-weight: bold;
        color: #222;
        font-size: 18px;
      }
    }
  }

  .header-menu-container & {
    display: block !important;
  }

  .close {
    position: absolute;
    top: 15px;
    right: 15px;
    fill: #aaa;
    display: flex;
    font-size: 32px;
    cursor: pointer;
    &:hover {
      cursor: pointer;
      fill: #666;
    }
  }
}

.header-menu-backdrop {
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(74, 74, 74, 0.4);
  z-index: 999;
}
</style>

<script>
import { mapState, mapGetters } from 'vuex';
import Notifications from './Notifications.vue';
import { focus } from 'vue-focus';

export default {
  directives: { focus: focus },
  data() {
    return {
      top: 0,
      right: null,
      left: null,
    };
  },
  computed: {
    resourceEditor() {
      const user = this.currentUser;
      return (
        user.permissions.includes('edit_resources') ||
        user.admin_level == 'sales'
      );
    },
    containerStyles() {
      if (this.left) {
        return {
          top: this.top + 'px',
          left: this.left + 'px',
          opacity: this.menuOpen ? 1 : 0,
        };
      } else if (this.right) {
        return {
          top: this.top + 'px',
          right: this.right + 'px',
          opacity: this.menuOpen ? 1 : 0,
        };
      }
      return {};
    },
    visibleLanguages() {
      return this.currentEdition.languages.filter(
        (lang) => this.$i18n.locale !== lang.code
      );
    },
    homeDestination() {
      if (this.currentEdition.enable_home_page) {
        return { name: 'home', hash: "#welcome" };
      } else {
        return '/welcome';
      }
    },
    ...mapState(['menuOpen']),
    ...mapGetters(['currentEdition', 'currentUser']),
  },
  watch: {
    menuOpen() {
      if (this.menuOpen) {
        this.$store.dispatch('fixPage');
        let triggerElement = document
          .getElementsByClassName('open-' + this.menuOpen)[0]
          .getBoundingClientRect();
        let top = triggerElement.top + window.scrollY;
        if (this.menuOpen === 'profile' || this.menuOpen === 'notifications') {
          // Right aligned menu
          var right =
            window.document.body.clientWidth -
            triggerElement.left -
            triggerElement.width;
          this.top = top;
          this.right = right > 10 ? right : 10;
          this.left = null;
        } else {
          // Left aligned menu
          var left = triggerElement.left;
          this.top = top;
          this.right = null;
          this.left = left > 10 ? left : 10;
        }
      } else {
        this.$store.dispatch('unfixPage');
      }
    },
  },
  methods: {
    setLanguage(lang) {
      document.cookie = `_LOCALE_=${lang.code};path=/;max-age=31536000`;
      this.$i18n.locale = lang.code;
      this.$moment.locale(lang.code);
      window.location.reload();
    },
    handleMenuClick(event) {
      // Close menu if any link inside it is clicked
      if (event.target.tagName === 'A') {
        this.closeMenu();
      }
    },
    closeMenu() {
      this.$store.commit('setMenuOpen', null);
    },
  },
  components: {
    Notifications,
  },
};
</script>
